export const SENTIMENT_TYPES = {
  POSITIVE: 1,
  NEGATIVE: -1,
  NEUTRAL: 0,
  UNKNOWN: null
};

export const SENTIMENT_ICON_COMPONENTS = {
  [SENTIMENT_TYPES.POSITIVE]: "PositiveIcon",
  [SENTIMENT_TYPES.NEGATIVE]: "NegativeIcon",
  [SENTIMENT_TYPES.NEUTRAL]: "NeutralIcon",
  [SENTIMENT_TYPES.UNKNOWN]: "UndefinedIcon"
};

export const SENTIMENT_NAMES = {
  [SENTIMENT_TYPES.POSITIVE]: "positive",
  [SENTIMENT_TYPES.NEGATIVE]: "negative",
  [SENTIMENT_TYPES.NEUTRAL]: "neutral",
  [SENTIMENT_TYPES.UNKNOWN]: "unknown"
};
